<template>
    <header class="zui-header english-header" :class="{headerActive:headerActive,borderGrey:borderGrey}">
        <!-- <logo type="xiaoyanyun" href="/"></logo> -->
        <div class="zui-logo" @click="onClick"></div>
        <p class="zui-logo-text">
            <span class="time">{{ time }}</span>
        </p>
        <p class="zui-logo-text">
            <img :src="iconUrl" alt="" v-show="iconUrl != ''" class="temp-icon">
            <span>{{ temp }}</span>
        </p>
        <el-dropdown class="zui-button" style="" v-for="(item,index) in menus" :key="item.name"
                     placement="bottom-start">
			<span class="el-dropdown-link zui-button zui-top" @click="onButtonClickMenu(item.route,item)">
				{{item.name}}
			</span>
            <el-dropdown-menu class="dropdown-menu zui-dropdown" slot="dropdown">
                <el-dropdown-item class="zui-button"
                                  :class="(currentPath === item_.route && currentPoint === item_.id) ? 'active' : ''"
                                  v-for="(item_,index) in item.children" :key="item_.id">
					<span class="el-dropdown-link" @click="onSubClick(item_.route, item_)">
						{{item_.name}}
					</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <div class="zui-right-btn">
            <div class="changeLang">
                <el-dropdown trigger="click" @command="onButtonClick">
					<span class="el-dropdown-link zui-rightcol">
						language<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="/home">chinese</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dropdown class="mobile-navigator" trigger="click" @command="onButtonClick" :hide-on-click='false'>
			<span class="el-dropdown-link zui-rightcol" style="position: relative;top: 2px;">
				menu<i class="el-icon-s-unfold el-icon--right"style="position: relative;top: 1px;"></i>
			</span>
            <el-dropdown-menu slot="dropdown">
                <template v-for="item in menus">
                    <el-dropdown-item :command="item.route"
                                      v-if="!item.children">{{item.name}}</el-dropdown-item>
                    <el-dropdown-item v-else>
                        <el-dropdown placement='right-start' @command="onButtonClick">
							<span class="el-dropdown-link">
								{{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
                            <el-dropdown-menu slot="dropdown">
                                <template v-for='items in item.children'>
                                    <el-dropdown-item :command="items.route">{{items.name}}</el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </el-dropdown-item>
                </template>
            </el-dropdown-menu>
        </el-dropdown>

    </header>
</template>
<script>
    import moment from 'moment';
    import './less/header.css'
    import ZuiButton from '../components/Button'
    import NcNav from '../components/template/NcNav.vue'
    import Logo from './Logo'
    import axios from "axios";
    import Util from '../Util'
    import {postMgrApiVisitItem,postVisitUnique} from "~/api/CmsApi";
    export default {
        components: {
            ZuiButton,
            Logo,
            NcNav
        },
        props: {
            logoType: {
                default: 'zhichou'
            },
            headerActive: {
                type: Boolean,
                default: false
            },
            borderGrey: {
                type: Boolean,
                default: false
            },
            headerIndex: {
                type: Number,
                default: 0
            },
            navConfigList: {
                type: Array,
                default: function() {
                    return []
                }
            },
            wenjuan: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                time: moment(new Date()).format('DD/MM/YYYY'),
                temp: '-',
                iconUrl: '',
                context: '/new',
                currentPath: '',
                currentPoint: '',
                menus: [{
                    name: 'Home',
                    route: '/englishIndex'
                },
                    {
                        name: 'Travel Info',
                        route: '/TravelInfo/AboutUs',
                        children: [{
                            name: 'About US',
                            id: 'one',
                            route: '/TravelInfo/AboutUs'
                        }, {
                            name: 'Notice',
                            id: 'two',
                            route: '/TravelInfo/Notice'
                        }, {
                            name: 'Videos',
                            id: 'three',
                            route: '/TravelInfo/Videos'
                        }, {
                            name: 'Pictures',
                            id: 'four',
                            route: '/TravelInfo/Pictures'
                        }]
                    },
                    {
                        name: 'Play&Stay',
                        route: '/PlayStay/Hotel',
                        children: [{
                            name: 'Hotel',
                            id: 'one',
                            route: '/PlayStay/Hotel'
                        }, {
                            name: 'How to Play',
                            id: 'two',
                            route: '/PlayStay/HowToPlay'
                        }, {
                            name: 'Local Gift',
                            id: 'three',
                            route: '/PlayStay/Gift'
                        }]
                    },
                    {
                        name: 'Culture',
                        route: '/Culture/Buddhist',
                        children: [{
                            name: 'Buddhist Culture',
                            id: 'one',
                            route: '/Culture/Buddhist'
                        }, {
                            name: 'Martial Arts Culture',
                            id: 'two',
                            route: '/Culture/Martial'
                        }, {
                            name: 'Tea Culture',
                            id: 'three',
                            route: '/Culture/Tea'
                        }, {
                            name: 'Food Culture',
                            id: 'four',
                            route: '/Culture/Food'
                        }]
                    },
                    {
                        name: 'Events',
                        route: '/Events'
                    },
                ]
            }
        },
        mounted() {
            let ivue = this;
            this.getWeather();
            this.$nextTick(function() {
                ivue.currentPath = window.location.pathname.replace(ivue.context, '');
                console.log(ivue.currentPath)
                ivue.currentPoint = ivue.$route.query.point;
                console.log(ivue.currentPoint)
                if (ivue.currentPoint) {
                    var index = ['one', 'two', 'three', 'four', 'five'].indexOf(ivue.currentPoint);
                    // setTimeout(function() {
                    // 	ivue.$refs.ncNav.handleNavItemClick({
                    // 		id: ivue.currentPoint
                    // 	}, index);
                    // }, 500);
                }
            });
           
            ivue.ifPC()
        },
        methods: {
            openMenu: function() {
                this.$refs.droplist.show()
            },
            onButtonClick: function(path) {
                let ivue = this;
                if (path && window.location.pathname !== ivue.context + path){
                    this.$openNewWindow(ivue.context + path);
                }
            },
            onButtonClickMenu: function(path,item) {
                let ivue = this;
                let name = item.name
                if(name){
                    ivue.getVisits(name)
                }
                if (path && window.location.pathname !== ivue.context + path)
                    if(path === '/englishIndex'){
                        this.$openNewWindow(ivue.context + path);
                    }
            },
            onSubClick: function(path, item) {
                let ivue = this;
                let name = item.name
                ivue.getVisitsEn(name)
                if (window.location.pathname !== ivue.context + path){
                    this.$openNewWindow({
                        path: ivue.context + path + '?point=' + item.id
                    });
                }
                else {
                    var index = ['one', 'two', 'three', 'four', 'five'].indexOf(item.id);
                    this.currentPoint = item.id;
                    // this.$refs.ncNav.handleNavItemClick(item, index);
                }
            },
            onClick: function(e) {
                location.assign('/')
            },
            getWeather() {
                axios.get('https://zylsweather.lintrondata.com/weatherkit/weatherjson/emeishan').then(res => {
                    if (res.data.resultcode == 0) {
                        // 现在温度
                        this.temp = res.data.weatherJson.today.cur_temp;
                        // 天气线型图标站内地址
                        this.iconUrl = res.data.weatherJson.today.iconsitetianqi2;
                    }
                });
            },
            sideClick(id) {
                let ivue = this;
                console.log(id);
                ivue.currentPoint = id;
            },
            //访问量
            getVisitsEn(name) {
                const param = { itemCateName:name };
                postMgrApiVisitItem(param).then(res => {
                    if (res.code === 0) {

                    } else {

                    }

                })
            },
            //判断移动端、pc端
			ifPC(){
				let ifpc = (Util.os().android || Util.os().iPhone) ? 'mobile' : 'pc'
                this.getVisitsUnique(ifpc,"english")
                // console.log(ifpc)
			},
            //独立ip访问量
            getVisitsUnique(ifpc,name) {
                const param = { endType:ifpc,languageType: name};
                postVisitUnique(param).then(res => {
                    if (res.code === 0) {

                    } else {

                    }

                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/english_header.vue